import { ToolbarActionKey } from "../../actions/ActionKeys";
import { ToolbarAction } from "../../actions/toolbar";

interface State {
  showDetailedStatus: boolean;
}

export const toolbar = (
  state: State = { showDetailedStatus: false },
  action: ToolbarAction
) => {
  switch (action.type) {
    case ToolbarActionKey.TOGGLE_DETAILED_STATUS_SHOWING:
      return { ...state, showDetailedStatus: !state.showDetailedStatus };
    default:
      return state;
  }
};
